export default __webpack_public_path__ + "static/media/template_pro__0010_17---TanXuan.00add6b3.png";